import { render, staticRenderFns } from "./SingleSubAccount.vue?vue&type=template&id=189ab311&scoped=true&"
import script from "./SingleSubAccount.vue?vue&type=script&lang=js&"
export * from "./SingleSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./SingleSubAccount.vue?vue&type=style&index=0&id=189ab311&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ab311",
  null
  
)

export default component.exports